<div class="row align-items-center">
  <div class="col-8">
    <input
      #dobInput
      id="fieldCprDob"
      name="fieldCprDob"
      class="form-control"
      pattern="[0-9]{6}"
      minlength="6"
      maxlength="6"
      type="text"
      inputmode="numeric"
      (input)="onDobInput($event, 'dob')"
      (change)="changed()"
      [(ngModel)]="dob"
      (blur)="onBlur()" />
    <div class="validationmessage">Indtast venligst dit CPR-nummer.</div>
  </div>

  <div class="col-auto p-0 d-block">-</div>

  <div class="col">
    <input
      #checkInput
      id="fieldCprCtrl"
      name="fieldCprCtrl"
      class="form-control"
      pattern="[0-9]{4}"
      minlength="4"
      maxlength="4"
      type="text"
      inputmode="numeric"
      (input)="onDobInput($event, 'check')"
      (change)="changed()"
      [(ngModel)]="check"
      (blur)="onBlur()" />
    <div class="validationmessage"></div>
  </div>
</div>
